import {ExDossier} from './ex-dossier';

import {DossierExpert as DossierExpertClass} from '../api/DossierExpert';
import {DossierExpert as DossierExpertInterface} from '../../interface/api/DossierExpert';
import {ExUtilisateur} from './ex-utilisateur';
import {ExAide} from './ex-aide';

export enum DossierExpertStatut {
    NouvelleNomination = 'nouvelle-nomination',
    EnCours = 'expertise-en-cours',
    EnCoursAvecLiens = 'expertise-en-cours-lien-interet',
    Termine = 'expertise-terminee',
    TermineAvecLiens = 'expertise-terminee-lien-interet',
    Refusee = 'expertise-refusee'
}


export class ExDossierExpert extends DossierExpertClass {

    public expertCanShowDossier = false;
    public expertCanShowDossierLight = false;
    public aideDossier = null;

    // La libelle du statut est configuré en fonction de l'état et de la déclaration d'un lien
    public statut = '';
    public statutClass = '';


    constructor(options: DossierExpertInterface = null) {
        super();
        if (options) {
            Object.assign(this, options);
        }

        if (this.dossier) {
            this.dossier = new ExDossier(this.dossier);
        }

        if (this.expert) {
            this.expert = new ExUtilisateur(this.expert);
        }


        if (this.dossier && this.dossier['aide'] !== undefined && typeof this.dossier['aide'] === 'object') {
            this.aideDossier = new ExAide(this.dossier['aide']);
        }

        this.updateStatutAndRules();


    }

    public updateStatutAndRules(): void {

        switch(this.etat) {
            case 0 :
                this.statut = `front.expertises.statutNouvelleNomination`;
                this.statutClass = DossierExpertStatut.NouvelleNomination;
                this.expertCanShowDossier = false;
                this.expertCanShowDossierLight = true;
                break;
            case 1 :
                if (this.lienDeclare) {
                    this.statut = `front.expertises.statutExpertiseEnCoursEtLien`;
                    this.statutClass = DossierExpertStatut.EnCoursAvecLiens;
                } else {
                    this.statut = `front.expertises.statutExpertiseEnCours`;
                    this.statutClass = DossierExpertStatut.EnCours;
                }
                this.expertCanShowDossier = true;
                this.expertCanShowDossierLight = true;
                break;
            case 5 :
                if (this.lienDeclare) {
                    this.statut = `front.expertises.statutExpertiseTermineeEtLien`;
                    this.statutClass = DossierExpertStatut.TermineAvecLiens;
                } else {
                    this.statut = `front.expertises.statutExpertiseTerminee`;
                    this.statutClass = DossierExpertStatut.Termine;
                }
                this.expertCanShowDossier = true;
                this.expertCanShowDossierLight = true;
                break;
            case 2 :
                this.statut = `front.expertises.statutExpertiseRefusee`;
                this.statutClass = DossierExpertStatut.Refusee;
                this.expertCanShowDossier = false;
                this.expertCanShowDossierLight = true;
                break;
        }


        if (this.dossier == null || +this.dossier['statut'] === 3 || +this.dossier['statut'] === 4 || +this.dossier['statut'] === 1) {
            this.expertCanShowDossier = false;
        }

        return;

    }

    public getNoteGlobale() {
        const noteGlobale: any = this['noteGlobale'];
        if(noteGlobale){
            return noteGlobale;
        }
        return '';
    }



}
